import axios from 'axios';
import FormHelperMixin from '@SHARED/js/Vue/mixins/FormHelperMixin';
import template from './CustomerUserLoginComponent.html';

export default {
  template,

  mixins: [FormHelperMixin],

  data() {
    return {
      mobile: '',
      password: '',
      remember: false,
      isLoading: false,
      hasSuccess: false,
    };
  },

  computed: {},

  methods: {
    hasValidInput() {
      return this.mobile.length > 1 && this.password.length > 1;
    },

    submitLogin() {
      this.hasSuccess = false;
      this.isLoading = true;
      this.clearErrors();

      axios.post(
          '/api/v1/customer-user-auth/login',
          { mobile: this.mobile, password: this.password, remember: this.remember },
        ).then((response) => {
          window.authUserHash = response.data.authUserHash;
          this.hasSuccess = true;

          setTimeout(() => {
            this.$emit('login-customer-user-success', response.data);
          }, 500);
        })
        .catch(() => {
          this.hasSuccess = false;
          this.addAttrError('loginFailed', 'Brukernavn og passord du har angitt, stemmer ikke overens med noen konto. Skriv nummer uten +47 eller 47 og sjekk at du har skrevet passordet riktig.');
          this.$emit('login-customer-user-fail');
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
